import React, { ReactNode } from 'react';

export type StreamState = 'EMPTY' | 'LOADING' | 'SYNCED';

interface StreamProps {
  title: string;
  children: ReactNode;
  className?: string;
  maxHeight?: string;
  state?: StreamState;
}

const Stream: React.FC<StreamProps> = ({ 
  title, 
  children, 
  className = "", 
  maxHeight = "auto",
  state = 'SYNCED'
}) => {
  const renderContent = () => {
    switch (state) {
      case 'LOADING':
        return (
          <div className="flex items-center justify-center py-12">
            <div className="flex flex-col items-center space-y-4">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-400"></div>
              <p className="text-gray-400 text-sm">Connecting...</p>
            </div>
          </div>
        );
      
      case 'EMPTY':
        return (
          <div className="text-center text-gray-400 py-8">
            <p>No data available</p>
          </div>
        );
      
      case 'SYNCED':
      default:
        return (
          <div className="space-y-4">
            {/* Cards List */}
            <div className="overflow-x-hidden" style={{
                height: "calc(100vh - 160px)"
            }}>
              {children}
            </div>
          </div>
        );
    }
  };

  return (
    <div className={`rounded-lg p-4 pt-0 flex flex-col ${className}`}>
      { title && (
        <div className="flex justify-between items-center mb-4 flex-shrink-0">
          <h2 className="text-sm font-semibold text-white truncate">{title}</h2>
        </div>
      )}
      <div 
        className="flex-1 overflow-y-auto overflow-x-hidden"
        style={{ maxHeight: maxHeight }}
      >
        {renderContent()}
      </div>
    </div>
  );
};

export default Stream; 